module.exports = __webpack_public_path__ + "img/maintop.c4e4fae.png";